import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { authData } from "src/app/util/auth";
import { errorHandler } from "src/app/util/errorHandler";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-payment-tranzgate-list",
  templateUrl: "./payment-tranzgate-list.component.html",
  styleUrls: ["./payment-tranzgate-list.component.scss"],
})
export class PaymentTranzgateListComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private httpClient: HttpClient
  ) {}
  session = "";
  term = "0";
  sessions: any = [];
  notification: any = {};

  payload: any;
  pendingWallet: any = null;
  includeWallet = true;
  loading = false;
  skeletonLoader = true;

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + authData().Token,
    }),
  };

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.session = params.id;
      this.term = params.term || 0;
      console.log(params);
      const baseUrl = `${environment.BASE_URL}/payments/tranzgatefeeslist?session=${this.session}&term=${this.term}`;
      this.httpClient.get(baseUrl, this.httpOptions).subscribe({
        next: (res: any) => {
          if (res.Success) {
            this.payload = res.Data;
            this.pendingWallet = res.Data?.find((fee: any) => fee.PendingWallet)?.PendingWallet ?? null;
          } else {
            this.notification = errorHandler(res);
          }
        },
        error: (err: any) => {
          this.notification = errorHandler(err);
        },
        complete: () => {
          this.loading = false;
          this.skeletonLoader = false;
        },
      });
    });
  }

  payOnTranzgate(req: any) {
    if (!req) return;

    this.loading = true;
    this.notification = {};

    const callBackUrl =
      `${environment.BASE_URL}/payments/RedirectFromTrazgate?company=${authData().Company}`;
    const baseUrl = `${environment.BASE_URL}/payments/payWithTranzgate?session=${this.session}&term=${this.term}&tranzgateClientId=${req.TranzgateClientId}&includeWallet=${this.includeWallet}`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe({
      next: (res: any) => {
        if (res.Success) {
          const { ResponseText, StudentFullName } = res.Data;
          let URL = `${environment.TRANZGATE_URL}`;
          URL += `MakePayment.aspx?id=${ResponseText}`;
          URL += `&allowupdate=1&allowupdateamount=1`;
          URL += `&customername=${StudentFullName}`;
          URL += `&returnurl=${encodeURIComponent(callBackUrl)}`;

          location.href = URL;
        } else {
          this.notification = errorHandler(res);
        }
      },
      error: (err: any) => {
        this.notification = errorHandler(err);
      },
      complete: () => {
        this.loading = false;
      },
    });
  }
}
